import { classNamesFunction, IStyle } from '@fluentui/react';

export interface ITermsOfUseCardStyles {
  panelClass: IStyle;
  iconClass: IStyle;
  panelHeadingClass: IStyle;
  contentTitleClass: IStyle;
  contentInfoClass: IStyle;
  panelHeadingCollapsedClass: IStyle;
}
export const styles: ITermsOfUseCardStyles = {
  panelClass: {
    minHeight: '64px',
  },
  iconClass: {
    marginLeft: '12px',
    fontSize: 'large',
  },
  panelHeadingClass: {
    cursor: 'pointer',
    paddingLeft: '20px',
    paddingRight: '30px',
    display: 'table',
    textAlign: '#{$relative-left}',
    width: '100%',
  },
  contentTitleClass: {
    fontSize: '16px',
    fontWeight: '500',
  },
  contentInfoClass: {
    fontSize: '12px',
  },
  panelHeadingCollapsedClass: {
    /* symbol for "collapsed" panels */
    content: 'e258' /* adjust as needed, taken from bootstrap.css */,
    float: '#{$relative-right}' /* adjust as needed */,
    minHeight: '72px',
  },
};

const getClassNames = classNamesFunction<{}, ITermsOfUseCardStyles>();
export const classNames = getClassNames(styles);
